/**
 * Navigate to billing for a star pack with psc2 (return URL) and psc3 (purchase source / admin analytics).
 */
export function openStarPackPurchaseUrl(pack, psc3, returnUrlOverride) {
    if (!pack?.purchaseUrl) {
        return false
    }
    const fallbackReturn =
        typeof window !== 'undefined' ? window.location.pathname + window.location.search : ''
    const psc2 = returnUrlOverride != null ? returnUrlOverride : fallbackReturn
    const source = psc3 != null && String(psc3) !== '' ? psc3 : 'direct'
    const separator = pack.purchaseUrl.includes('?') ? '&' : '?'
    window.location.href =
        pack.purchaseUrl +
        separator +
        'psc2=' +
        encodeURIComponent(psc2) +
        '&psc3=' +
        encodeURIComponent(source)

    return true
}
